module.exports = __webpack_public_path__ + "assets/img/typeIcon-1.076bb6d9.svg";